import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type dyltCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const dyltDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const dylt: CarrierDef<dyltCredType> = {
  name: 'Daylight Transport',
  scac: 'dylt',
  credentialTypes,
  locationCredentialTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'guaranteed', name: 'Guaranteed', guaranteed: true },
  ],
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: [
    'provisioning',
    'rating',
    'bol',
    'pickup',
    'tracking',
    'documents',
    'invoice',
    'profinder',
  ],
  documentTypes: dyltDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
